items:
- name: learn
  route: false
  children:
    - heading: docs
    - name: guide
      page: guide/intro
    - name: api
    - name: examples
      url: https://github.com/stalniy/casl-examples
    - name: cookbook
      page: cookbook/intro
- name: ecosystem
  route: false
  children:
    - heading: packages
    - name: pkg-prisma
      page: package/casl-prisma
    - name: pkg-mongoose
      page: package/casl-mongoose
    - name: pkg-angular
      page: package/casl-angular
    - name: pkg-react
      page: package/casl-react
    - name: pkg-vue
      page: package/casl-vue
    - heading: help
    - name: questions
      url: https://stackoverflow.com/questions/tagged/casl
    - name: chat
      url: https://github.com/stalniy/casl/discussions
    - heading: news
    - name: tweeter
      url: https://twitter.com/sergiy_stotskiy
    - name: blog
      url: https://sergiy-stotskiy.medium.com
- name: consulting
- name: support
  route: false
  children:
    - name: support-casl
    - name: support-ukraine
      url: https://prytulafoundation.org/en/home/support_page
      rel: noopener noreferrer

footer:
  - icon: github
    url: https://github.com/stalniy/casl
  - icon: twitter
    url: https://twitter.com/sergiy_stotskiy
  - icon: medium
    url: https://sergiy-stotskiy.medium.com
